import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

import { useAuth0 } from "@auth0/auth0-react";

export default function StreamSwagger() {
  const { getAccessTokenSilently } = useAuth0();

  return (
    <SwaggerUI
      url={`${process.env.REACT_APP_API_URL}rv_stream_docs/openapi.json`}
      requestInterceptor={async (req) => {
        const token = await getAccessTokenSilently();
        req.headers.Authorization = `Bearer ${token}`;
        return req;
      }}
    />
  );
}
